export enum ElementGroup {
	BaseElement = 'BASE_ELEMENT_GROUP',
	MainElement = 'MAIN_ELEMENT_GROUP',
	AdditionalElement = 'ADDITIONAL_ELEMENT_GROUP'
}